var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmotionLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1489 32.75C25.9226 32.75 33.0478 25.7055 33.0478 17C33.0478 8.29455 25.9226 1.25 17.1489 1.25C8.37517 1.25 1.25 8.29455 1.25 17C1.25 25.7055 8.37517 32.75 17.1489 32.75Z",
    fill: "url(#paint0_linear_7022_33087)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7022_33087)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0642 14.1996C20.2073 14.1996 20.3128 14.1996 20.4191 14.1996C21.857 14.1996 23.295 14.1932 24.7329 14.2036C25.4139 14.2084 25.9343 14.648 26.0598 15.2811C26.1796 15.8845 25.8647 16.4848 25.2868 16.755C25.2261 16.7837 25.1645 16.8109 25.1014 16.8397C25.8375 17.671 25.6537 18.7308 24.5786 19.2032C25.4307 20.2167 24.8984 21.231 24.0255 21.5428C24.0535 21.5843 24.0751 21.6227 24.1031 21.6547C24.4883 22.0959 24.5826 22.593 24.3461 23.1278C24.1007 23.6801 23.6387 23.9255 23.0504 23.9223C21.8522 23.9151 20.6541 23.8935 19.4559 23.8783C18.1882 23.8623 16.9198 23.8487 15.6521 23.8304C14.9407 23.82 14.5674 23.4403 14.5666 22.7289C14.565 20.3126 14.5738 17.8956 14.5586 15.4793C14.5562 15.0381 14.6713 14.6608 14.9727 14.3643C15.6265 13.7208 16.3051 13.103 16.9717 12.4723C17.385 12.0815 17.799 11.6922 18.205 11.2933C18.5503 10.9536 18.6862 10.5316 18.7014 10.0496C18.7198 9.46215 18.7518 8.87227 18.8213 8.28878C18.8804 7.78921 19.0043 7.72207 19.4991 7.79001C20.4718 7.9227 21.0274 8.50778 21.164 9.50291C21.2919 10.4389 21.1105 11.3341 20.8259 12.2109C20.6325 12.8072 20.3775 13.3827 20.1505 13.9678C20.1266 14.0293 20.1042 14.0917 20.065 14.198L20.0642 14.1996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.92276 19.021C8.92276 17.7829 8.92116 16.5439 8.92276 15.3058C8.92356 14.5929 9.29843 14.2148 10.0106 14.2108C10.8395 14.2068 11.6684 14.206 12.4972 14.2108C13.187 14.2148 13.5755 14.5961 13.5763 15.2898C13.5811 17.7765 13.5819 20.2631 13.5763 22.7497C13.5747 23.4435 13.1854 23.8256 12.4964 23.8296C11.658 23.8344 10.8187 23.8352 9.97944 23.8296C9.30563 23.8248 8.92356 23.4379 8.92196 22.7657C8.91957 21.5172 8.92196 20.2687 8.92196 19.021H8.92276Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7022_33087",
    x1: 17.1489,
    y1: 2,
    x2: 17.1489,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A0E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0077E6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7022_33087"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.1618,
    height: 16.1538,
    fill: "white",
    transform: "translate(8.92285 7.76923)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmotionLike);
export default __webpack_public_path__ + "static/media/emotion_like.c2b46d917626b78418610480c47dc741.svg";
export { ForwardRef as ReactComponent };